/*
|--------------------------------------------------------------------------
|
| 用于本地调试组件，配合 npm script 的 VUE_APP_COMP 参数来决定载入哪个组件调试
|
|--------------------------------------------------------------------------
*/
import Vue from 'vue';
import libProperties from './components/HelloWorld.vue';

const compName = process.env.VUE_APP_COMP || 'App';
console.log(compName)

  new Vue({
    render: h => h(libProperties),
  }).$mount('#app');

